import { client } from '..';
import { SeasonMission, SeasonMissionParticipant, SeasonMissionsResponse } from '../models/seasonMissionModel';

export const getSeasonMissions = async (): Promise<SeasonMissionsResponse> => {
  const url = `/mission-seasons`;

  const response = await client.get(url);

  return response.data;
};

export const getSeasonMissionDetail = async ({ missionId }: { missionId: string }): Promise<SeasonMission> => {
  const url = `/mission-seasons/${missionId}`;

  const response = await client.get(url);

  return response.data;
};

export const getSeasonMissionParticipants = async ({
  missionId
}: {
  missionId: string;
}): Promise<SeasonMissionParticipant[]> => {
  const url = `/mission-seasons/${missionId}/participants`;

  const response = await client.get(url);

  return response.data;
};
